/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popShare.vue?vue&type=template&id=1bee189e&scoped=true"
import script from "./popShare.vue?vue&type=script&lang=js"
export * from "./popShare.vue?vue&type=script&lang=js"
import style0 from "./popShare.vue?vue&type=style&index=0&id=1bee189e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee189e",
  null
  
)

export default component.exports